<template>

 <div class="container Auftrag">

<h3 class="pt-3 pb-3">Anfrage an die Cutterkollegen</h3>

<b-alert :show="message!=null" variant="info">{{ message }}</b-alert>

 <b-alert :show="errorMessage!=null" variant="danger">{{ errorMessage }}</b-alert>

<b-form v-if="!message" @submit="onSubmit" @reset="onReset">
  <b-form-group label-cols="3"
      id="input-group-1"
      label="Firma:"
      label-for="input-1">
       <b-form-input id="input-1" v-model="form.firmaFormular" type="text" placeholder="Den Firmennamen eingeben..." required/>
  </b-form-group>
  <b-form-group label-cols="3"
      id="input-group-2"
      label="Name:"
      label-for="input-2" >
       <b-form-input id="input-2" v-model="form.name" type="text" placeholder="Ihren Namen eingeben..." required/>
  </b-form-group>
  <b-form-group label-cols="3"
      id="input-group-3"
      label="Telefon:"
      label-for="input-3">
      <b-form-input id="input-3" v-model="form.telefon" type="text" placeholder="Ihre Telefonnummer für Rückfragen eingeben..." required/>
  </b-form-group>
  <b-form-group label-cols="3"
      id="input-group-4"
      label="E-Mail:"
      label-for="input-4">
    <b-form-input label-cols="3"
      id="input-1"
      v-model="form.email"
      type="email"
      placeholder="E-Mail Adresse eingeben..."
      required >
    </b-form-input>
  </b-form-group>
  <b-form-group label-cols="3"
      id="input-group-5"
      label="Datum:"
      label-for="input-5">
      <b-form-input id="input-5" v-model="form.datum" type="text" placeholder="Das Anfangsdatum eingeben..." required/>
  </b-form-group>
  <b-form-group label-cols="3"
      id="input-group-6"
      label="Schnittplatz bei:"
      label-for="input-6">
        <b-form-select
          id="input-6"
          v-model="form.schnittplatz"
          required>
          <option v-for="sp in schnittplaetze" v-bind:key="sp.id" :value=sp.id>{{sp.name}}</option>
        </b-form-select>
  </b-form-group>

  <b-form-group label-cols="3"
      id="input-group-8"
      label="Anzahl Tage:"
      label-for="input-8">
      <b-form-input id="input-8" v-model="form.tageFormular" type="text" placeholder="Dauer eingeben..." required/>
  </b-form-group>
  <b-form-group label-cols="3"
      id="input-group-9"
      label="Gagenvorschlag (8h):"
      label-for="input-9">
      <b-form-input id="input-9" v-model="form.gageFormular" type="text" placeholder="Bitte den Gagenvorschlag eingeben..." required/>
  </b-form-group>
  <b-form-group label-cols="3"
      id="input-group-10"
      label="Format:"
      label-for="input-10">
       <b-form-select
          id="input-6"
          v-model="form.formatId"
          required>
          <option value="null">Bitte wählen Sie ein Format...</option>
          <option v-for="sp in formate" v-bind:key="sp.id" :value="sp.id">{{sp.name}}</option>
        </b-form-select>
      <p v-if="fieldError['formatId']" class="alert alert-danger">{{fieldError['formatId']}}</p>

  </b-form-group>
  <b-form-group label-cols="3"
      id="input-group-11"
      label="Schnittsoftware:"
      label-for="input-11">
       <b-form-select
          id="input-6"
          v-model="form.skillId"
          required>
           <option value="null">Bitte wählen Sie eine Schnittsoftware...</option>
          <option v-for="sp in skills" v-bind:key="sp.id" :value="sp.id">{{sp.name}}</option>
        </b-form-select>
        <p v-if="fieldError['skillId']" class="alert alert-danger">{{fieldError['skillId']}}</p>
  </b-form-group>
  <b-form-group label-cols="3"
      id="input-group-12"
      label="Kunde:"
      label-for="input-12">
      <b-form-input id="input-12" v-model="form.kundeFormular" type="text" placeholder="Kundennamen eingeben..." required/>
  </b-form-group>
  <b-form-group label-cols="3"
      id="input-group-13"
      label="Sendung:"
      label-for="input-13">
      <b-form-input id="input-13" v-model="form.sendung" type="text" placeholder="Sendung eingeben..." required/>
  </b-form-group>
  <b-form-group label-cols="3"
      id="input-group-14"
      label="Thema:"
      label-for="input-14">
      <b-form-input id="input-14" v-model="form.thema" type="text" placeholder="Thema eingeben..." required/>
  </b-form-group>

  <b-form-group label-cols="3"
      id="input-group-15"
      label="Weitere Infos:"
      label-for="input-15">
     <b-form-textarea id="input-15" v-model="form.information" placeholder="zusätzliche Informationen..."></b-form-textarea>
  </b-form-group>

      <b-button type="submit" variant="primary">Jetzt unverbindlich anfragen</b-button>
      <b-button type="reset" variant="danger">Zurücksetzen</b-button>
    </b-form>

</div>
</template>

<script>
// use the public api
import api from '@/api/public'
const preset = { schnittplatz: 'Kunde', formatId: null, skillId: null }

export default {
  name: 'AuftragAnfrage',
  beforeCreate () {
    document.body.className = ''
  },
  async mounted () {
    this.skills = await api.skillList()
    this.formate = await api.formatList()
  },
  methods: {
    async onSubmit (event) {
      event.preventDefault()
      this.fieldError = []
      this.errorMessage = null
      this.message = null
      if (this.form.skillId == null) {
        this.fieldError['skillId'] = 'Bitte wählen Sie eine Software aus!'
      }
      if (this.form.formatId == null) {
        this.fieldError['formatId'] = 'Bitte wählen Sie ein Format aus!'
      }
      let httpForm = new FormData()
      for (let [key, value] of Object.entries(this.form)) {
        httpForm.append(key, value)
      }
      let result = await api.createAuftrag(httpForm)
      if (Object.keys(result).length > 0) {
        this.fieldError = result
        this.errorMessage = result.errorMessage
      } else {
        this.message = 'Danke für Ihren Auftrag, wir melden uns!'
        this.form = this.preset
      }
    },
    onReset (event) {
      event.preventDefault()
      // Reset our form values
      this.form = preset
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    }
  },
  data () {
    return {
      errorMessage: null,
      message: null,
      formate: [],
      skills: [],
      fieldError: [],
      schnittplaetze: this.$store.state.auth.baseData.schnittplaetze,
      form: preset
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/main/vue/components/AuftragAnfrage.vue